import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'class-names'
import without from 'lodash.without'
import {saveSchool,clearSchoolIntention} from '../../api/schoolWishList/index'
import Popup from '../../components/Popup'
import Toast from '../../components/Toast'
import OperationBtn from './OperationBtn'
import './Selected.less'
import union from "lodash.union";
import PopupCommon from "../../components/PopupCommon";
import schoolWishListVideoImg from '../../assets/svg/img-school-wish-list-video.png';
const MAX_SCHOOL_COUNT = 20;

class SchoolWishList extends Component {

  static propTypes = {
    codes: PropTypes.array,
      onSelectChange: PropTypes.func,
  }

  state = {
    showWarn: false,
    showToast: false,
    toastText: '',
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {

  }
  componentWillReceiveProps(n) {
    // console.log(n);
  }
  //点击学校查看详情
  handleSchoolClick(school) {
    const { history } = this.props
    history.push(`/schoolwishlist/school/${school.id}`)
  }
  //添加你喜欢的学校
  handleChooseSchool() {
    const { history, match } = this.props
    history.push(`${match.url}/choose`)
  }
  //删除学校
  handleRemoveMajor(data,selected, e) {
      const { selectedSchoolIds,selectedSchoolList } = this.props;
      const modify = data.id;
      if(selected){
          const newIds = without(selectedSchoolIds, modify);
          const newList=selectedSchoolList.filter(i=>i.id!=modify);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'deleted' ,
                  toastText1:  '已删除' ,
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }else {
          const newIds = union(selectedSchoolIds, [modify]);
          const newList= union(selectedSchoolList,[data]);
          this.setState(() => {
              return {
                  showToast: true,
                  toastIcon:  'success',
                  toastText1: '已添加',
                  toastText2: data.name,
              }
          });
          this.props.onSelectChange(newIds,newList)
          e.stopPropagation()
      }
  }
  //查看结果
  handleNext() {
    const { selectedSchoolIds } = this.props;
    let schoolIds=selectedSchoolIds.join(',');
    if (selectedSchoolIds.length > MAX_SCHOOL_COUNT) {
      this.setState(() => {
        return {
          showWarn: true,
        }
      })
    } else if(selectedSchoolIds.length===0){
        clearSchoolIntention().then(res=>{
            window.location.href = `/chooseCourse/stageThree`
        })
    } else {
        saveSchool(schoolIds).then(res=>{
            window.location.href = `/chooseCourse/stageThree`
        })
    }
  }
    handleClickVideoPlay=()=>{
        let {play}=this.state;
        let video=document.getElementById('video');
        play?video.pause():video.play();
        this.setState({
            play:!this.state.play
        })
    }
  render() {
    const {
      showToast,
      toastText1,
      toastText2,
      showWarn,
        showVideo,
      // showConfirm,
    } = this.state
    let {selectedSchoolIds,selectedSchoolList}=this.props;
    const nextStep = selectedSchoolIds.length <= MAX_SCHOOL_COUNT
    return (
      <div className="school-wish-list-wrapper school-selected-wrapper">
        <div className="detail-banner">
          <h1>
              <span>意向学校清单</span>
          </h1>
          <p>请将自己感兴趣的学校选入清单，并将数量控制在20个以内，系统将会在下一阶段根据清单中的内容提供选科分析结果。<br/>
              如果你还不太确定应该如何挑选你的意向院校，可以参考这份说明：<span onClick={()=>{this.setState({showVideo:true})}}>如何挑选合适的意向院校？</span></p>
        </div>
        <ul className="search-result">
            {
              selectedSchoolList.map((d,index)=>{
                return <li key={index} onClick={this.handleSchoolClick.bind(this,d)}>
                    <div className="school-logo" style={{ backgroundImage: `url(${d.logoUrl})` }}></div>
                    <div className="school-info">
                        <div className="school-info-inner">
                            <div className="school-info-inner-left">
                                <h5>{d.name}</h5>
                            </div>
                            <OperationBtn added={true} onClick={this.handleRemoveMajor.bind(this, d,true)} />
                        </div>
                    </div>
                </li>
              })
            }
        </ul>
        <div className="padding-btn">
          <button className="full" onClick={this.handleChooseSchool.bind(this)}>添加你喜欢的学校</button>
        </div>
        <div className={classNames({ 'next-step': true, 'disabled': !nextStep })}
             onClick={this.handleNext.bind(this)}>
            <p>{!nextStep ? '请继续减少清单中的学校数量' : '查看结果'}</p>
            <i>{selectedSchoolIds.length} / {MAX_SCHOOL_COUNT}</i>
        </div>
          {
              showVideo&&
              <PopupCommon show={showVideo}>
                  <div className='video-container'>
                      <video src="https://shijiesys-1256650073.cos.ap-beijing.myqcloud.com/public/shijie-sys/help/%E5%A6%82%E4%BD%95%E6%B7%BB%E5%8A%A0%E6%84%8F%E5%90%91%E5%AD%A6%E6%A0%A1%E6%B8%85%E5%8D%95.mp4" controls id='video' poster={schoolWishListVideoImg}>
                      </video>
                      {/*<div className="video-mask" onClick={this.handleClickVideoPlay}>*/}
                      {/*    {!this.state.play&&<img src={playIcon} alt="" />}*/}
                      {/*</div>*/}
                      <div className="title">如何挑选合适的意向院校</div>
                      <div className="close" onClick={()=>{this.setState({showVideo:false
                      ,play:false,})}}>
                          <svg t="1666465818226" className="icon" viewBox="0 0 1024 1024" version="1.1"
                               xmlns="http://www.w3.org/2000/svg" p-id="2174" width="18" height="18">
                              <path
                                  d="M621.714286 512 1002.057143 131.657143c29.257143-29.257143 29.257143-80.457143 0-109.714286-29.257143-29.257143-80.457143-29.257143-109.714286 0L512 402.285714 131.657143 21.942857c-29.257143-29.257143-80.457143-29.257143-109.714286 0-29.257143 29.257143-29.257143 80.457143 0 109.714286L402.285714 512 21.942857 892.342857c-29.257143 29.257143-29.257143 80.457143 0 109.714286 29.257143 29.257143 80.457143 29.257143 109.714286 0L512 621.714286l380.342857 380.342857c29.257143 29.257143 80.457143 29.257143 109.714286 0 29.257143-29.257143 29.257143-80.457143 0-109.714286L621.714286 512z"
                                  p-id="2175" fill="#EAEAEA"></path>
                          </svg></div>
                  </div>
              </PopupCommon>
          }
        <Popup confirmText={'我知道了'} show={showWarn} onConfirm={() => this.setState({ showWarn: false })}>
          <div className="popup-warn">
            <p>当前你所添加的意向学校一共{selectedSchoolIds.length}个，请继续了解不同的学校，将意向的学校缩减至{MAX_SCHOOL_COUNT}个</p>
          </div>
        </Popup>
        <Toast show={showToast} icon={'deleted'} onHide={() => this.setState({ showToast: false })}>
          <i>已删除</i>
          <p>{toastText2}</p>
        </Toast>
      </div>
    )
  }
}

export default SchoolWishList



// WEBPACK FOOTER //
// ./src/pages/SchoolWishListNew/Selected.js